import { AppBar, styled, Toolbar, Button } from '@mui/material'
import { Box } from '@mui/system'
import React, { Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Logo } from '../components/Main'
import { removeCookies } from '../utility/Cookies'
import { useSelector } from 'react-redux'

const Main = styled('main')(({ theme }) => ({
  ...theme.typography.mainContent,
  ...{
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    marginTop: '70px',
    [theme.breakpoints.up('md')]: {
      // TODO: Responsive
    },
    [theme.breakpoints.down('md')]: {},
    [theme.breakpoints.down('sm')]: {},
  },
}))

const AuthenticationLayout = () => {
  const { t } = useTranslation()
  const { account } = useSelector((state) => state.account)
  return (
    <>
      <AppBar
        enableColorOnDark
        position="absolute"
        color="inherit"
        elevation={0}
        sx={{
          bgcolor: 'white',
          padding: 0,
        }}
      >
        <Toolbar sx={{ padding: '0 20px' }}>
          <Box component="span" sx={{ flexGrow: 1 }}>
            <Logo />
          </Box>
          {account && (
            <Button
              color="inherit"
              onClick={() => {
                removeCookies('_wsso')
                removeCookies('_wssc')
                removeCookies('_wchat')
                removeCookies('wsc-summary-header')
                window.location = '/account/signin'
              }}
            >
              {t('menu.signout')}
            </Button>
          )}
        </Toolbar>
      </AppBar>
      <Main>
        <Outlet />
      </Main>
    </>
  )
}

export default AuthenticationLayout
